import awsdk from 'awsdk';

// Visit
// AdministeredIntake
// TrackerReminder
// Media

export const AgendaItemFollowUpType = awsdk.AWSDKAgendaItemFollowUpType;
export type AgendaItemFollowUpType = typeof AgendaItemFollowUpType;
